module.exports = __webpack_public_path__ + "img/yx2.0ab8f2e4.png";